import {
    getCornerUserUniqueIdObjectPrefix,
    getCustomCornerUserUniqueIdObjectPrefix,
    getCustomPanelUserUniqueIdObjectPrefix,
    getCustomZShapedPanelUniqueIdObjectPrefix,
    getPanelUserUniqueIdObjectPrefix,
} from "../forge/ids/userObjectIds";
import { CategoryType } from "../forge/typesManager/constants/panelTypeEnums";

/**
* Get the prefix for a panel's user unique ID based on its category
* @param categoryName The category of the panel
* @returns The prefix string
*/
export const getFacadeElementUserUniqueIdPrefix = (categoryName: CategoryType): string => {
    switch (categoryName) {
        case CategoryType.CustomPanel:
            return getCustomPanelUserUniqueIdObjectPrefix();
        case CategoryType.CustomCorner:
            return getCustomCornerUserUniqueIdObjectPrefix();
        case CategoryType.CustomZShapedPanel:
            return getCustomZShapedPanelUniqueIdObjectPrefix();
        case CategoryType.Corner:
            return getCornerUserUniqueIdObjectPrefix();
        default:
            return getPanelUserUniqueIdObjectPrefix();
    }
};

/**
* Format a panel's display ID with the appropriate prefix
* @param panel The panel object containing userUniqueId
* @param categoryName The category of the panel
* @returns Formatted ID string with prefix
*/
export const formatFacadeElementDisplayId = (panel: { userUniqueId: number }, categoryName: CategoryType): string => {
    return `${getFacadeElementUserUniqueIdPrefix(categoryName)}${panel.userUniqueId}`;
};
